module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl10 mt20"
  }, [_c('div', {
    staticClass: "mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("入驻进展：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.scheduleObj.schedule))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.scheduleObj.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n\t\t\t  (" + _vm._s(_vm.scheduleObj.content) + ")")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("基础信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb20"
  }, [_c('el-form', {
    ref: "basicForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.basicForm,
      "label-width": "207px"
    }
  }, [_c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("公司名称：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n\t\t\t    \t\t" + _vm._s(_vm.basicForm.supplierName) + "\n\t\t\t    \t")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("公司介绍：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n\t\t\t    \t\t" + _vm._s(_vm.basicForm.supplierIntro) + "\n\t\t\t    \t")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("线上店铺：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n\t\t\t    \t\t" + _vm._s(_vm.basicForm.otherPlatformShopUrl) + "\n\t\t\t    \t")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("办公地址：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.officeCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeAddress))])])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("品类信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.basicForm.supplierApplyCategories,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "categoryName",
      "label": "主营品类",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryDeposit",
      "label": "品类保证金（元）",
      "width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品类经营特许资质电子版",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.franchiseQualificationFile) ? _c('img', {
          staticClass: "pic_min_skan",
          attrs: {
            "src": scope.row.franchiseQualificationFile
          },
          on: {
            "click": function($event) {
              _vm.previewPic($event)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!scope.row.franchiseQualificationFile) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("供应商资质信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), (_vm.basicForm.categoryIsBook != 1) ? _c('el-form-item', {
    attrs: {
      "label": "公司注册地址："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredAddress))])]) : _vm._e(), _vm._v(" "), (_vm.basicForm.categoryIsBook == 1) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "出版社经营许可证电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.publicationBusinessLicenseFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册登记名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredName))])]), _vm._v(" "), (_vm.basicForm.categoryIsBook == 1) ? _c('el-form-item', {
    attrs: {
      "label": "注册登记地址："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredAddress))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册资金："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCapital) + "（单位：万）")]), _vm._v(" "), (_vm.basicForm.registeredCapitalType == 1) ? _c('span', [_vm._v("人民币")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.registeredCapitalType == 2) ? _c('span', [_vm._v("美元")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.licenseType != 3),
      expression: "basicForm.licenseType !=3 "
    }],
    attrs: {
      "label": "执照类型："
    }
  }, [(_vm.basicForm.licenseType == 1) ? _c('span', [_vm._v("普通营业执照")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 2) ? _c('span', [_vm._v("三证合一／五证合一")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.businessLicenseCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.businessLicenseFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.registeredCountry == 1),
      expression: "basicForm.registeredCountry == 1"
    }],
    attrs: {
      "label": "执照有效期："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("time")(_vm.basicForm.businessLicenseStartDate)))]), _vm._v(" --\n          \t"), _c('span', [_vm._v(_vm._s(_vm._f("time")(_vm.basicForm.businessLicenseEndDate)))])]), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "组织机构代码："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.orgCode))])]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "组织结构代码电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.orgCodeFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "税务登记证电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.taxFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户许可证电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.accountOpeningPermitFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人证件类型："
    }
  }, [(_vm.basicForm.personalCardType == 1) ? _c('span', [_vm._v("身份证")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.personalCardType == 2) ? _c('span', [_vm._v("护照")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人身份证件电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.personalCardFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "dib"
  }, [_vm._v("业务联系人信息")]), _c('span', {
    staticClass: "second_line"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contactName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contactMobile))])]), _vm._v(" "), (_vm.basicForm.contactLandline) ? _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contactLandline))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contactEmail))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contactQQ))])]), _vm._v(" "), (_vm.basicForm.contactPosition) ? _c('el-form-item', {
    attrs: {
      "label": "职务:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contactPosition))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同联系人信息")]), _c('span', {
    staticClass: "second_line"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contractContactName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contractContactMobile))])]), _vm._v(" "), (_vm.basicForm.contractContactLandline) ? _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contractContactLandline))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contractContactEmail))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contractContactQQ))])]), _vm._v(" "), (_vm.basicForm.contractContactPosition) ? _c('el-form-item', {
    attrs: {
      "label": "职务:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.contractContactPosition))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "dib"
  }, [_vm._v("客服系人信息")]), _c('span', {
    staticClass: "second_line"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.customContactName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.customContactMobile))])]), _vm._v(" "), (_vm.basicForm.customContactLandline) ? _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.customContactLandline))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.customContactEmail))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.customContactQQ))])]), _vm._v(" "), (_vm.basicForm.customContactPosition) ? _c('el-form-item', {
    attrs: {
      "label": "职务:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.customContactPosition))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dbe74c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplier/basicInfo.vue
// module id = 509
// module chunks = 0